


































































import Vue from 'vue'
import FakeLocalNumberStepper from '@/components/FakeLocalNumberStepper.vue'
import HomeDashboardTile from '@/components/HomeDashboardTile.vue'
import HomeDashboardTileType from '@/types/components/HomeDashboardTile.interface'
import HostNumberStepper from '@/components/HostNumberStepper.vue'
import { mapGetters } from 'vuex'
import Analytics from '@/services/Analytics'
export default Vue.extend({
    components: { FakeLocalNumberStepper, HomeDashboardTile, HostNumberStepper },
    props: {
        defaultType: {
            type: String,
            default: null
        }
    },
    data: () => ({
        activeIdx: null,
        loading: false,
        step: 1
    }),
    mounted() {
        //  Check if we have the default type prop
        const type = this.defaultType

        //  If we do, then route to that step
        const step =
            {
                local: 3,
                host: 4
            }[type] || 1

        //  Route to our step
        this.step = step
    },
    computed: {
        ...mapGetters(['phoneOrder', 'smsAccount', 'tenant']),
        numberTiles(): HomeDashboardTileType[] {
            return [
                {
                    title: 'Connect an Existing Landline or VoIP Phone Number',
                    description:
                        'Integrate an existing phone number with MessageDesk. This process occurs within 48 hours.',
                    chip: 'Most Popular',
                    text: 'Host Existing Phone Number',
                    textIcon: 'bi-arrow-right-circle-fill',
                    callback: () => (this.activeIdx = 0)
                },
                {
                    title: 'Keep your Temporary Phone Number',
                    description:
                        'You can use this temporary number during your 14-day free trial.',
                    text: `Your Temporary Number: ${this.$options.filters.phone(
                        this.smsAccount.msisdn
                    )}`,
                    color: this.phoneOrder ? 'rgba(0,0,0,0.26)' : '',
                    disabled: this.phoneOrder,
                    callback: () => (this.activeIdx = 1)
                },
                {
                    title: 'Get a New Local Phone Number',
                    description: 'Search phone numbers by entering a 3 digit area code.',
                    text: 'Search for a Local Phone Number by Area Code',
                    textIcon: 'bi-search',
                    callback: () => (this.activeIdx = 2)
                }
            ]
        }
    },
    methods: {
        confirm() {
            //  We have to route to different functions depending on our index
            const idx = this.activeIdx

            //  Our type depends on the index
            const type = {
                0: 'Hosted',
                1: 'Temporary',
                2: 'Local'
            }[idx]

            //  Report to analytics
            Analytics.track('GetPhoneNumberStarted', {
                phone_number_type: type
            })

            //  Route using this switch object
            return {
                0: () => (this.step = 4),
                1: () => this.keepTemporary(),
                2: () => (this.step = 3)
            }[idx]()
        },
        async keepTemporary(): Promise<void> {
            //  Create our payload for our phone order
            const payload = {
                type: 'temporary',
                state: 'complete',
                msisdn: this.smsAccount.msisdn,
                tenant_id: this.tenant.id
            }

            //  Start loading
            this.loading = true

            //  Send a request out that will create a phone order
            await this.$store.dispatch('phoneOrderPost', payload)

            //  Stop our loading
            this.loading = false

            //  Go to our next step
            this.step = 2
        },
        submit(type: string) {
            //  Include our type in our submit (this is the number type)
            this.$emit('submit', type)
        }
    }
})
